define('views/modules/template/edit/calendar/calendar-component/template-calendar-item-sortable-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-sortable-list',
    'views/modules/template/edit/calendar/calendar-component/template-calendar-day-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VCalendarItemSortableList,
    VTemplateCalendarDayItem
) {

    var VTemplateCalendarItemSortableList = VCalendarItemSortableList.extend({
        item: VTemplateCalendarDayItem,
        onNewItem: _.noop
    });

    return VTemplateCalendarItemSortableList;
});

